import Entity from '../Entity';

export default class NotificationSettingCategory implements Entity {
  constructor(public id: number, public name: string) {}
}
